import { tw } from "@careinfo/tailwind";

interface Props {
  title: string;
  time: string;
  value: string;
}

export default function ({ title, time, value }: Props) {
  return (
    <div
      className={tw`w-full rounded-md bg-[#fefefe] p-4`}
      style={{
        boxShadow: "0px 1px 6px 0px #00000040",
      }}
    >
      <div className={tw`flex justify-between`}>
        <h3 className={tw`text-xl leading-8 font-semibold`}>{title}</h3>
        <p
          className={tw`text-base flex items-center justify-center text-[#272727] border rounded-[100vh] px-2 py-1`}
        >
          <span className={tw`inline-block`}>{time}</span>
        </p>
      </div>
      <p
        className={tw`text-[#272727] leading-8 text-lg text-center pt-7 pb-12`}
      >
        {value}
      </p>
    </div>
  );
}
